import { defineComponent, onUnmounted, ref, watch } from 'vue'
import styles from './styles.module.scss'
import Play from './image/play.png'
import { useComponentStore } from '../../nsh5/localStores/component'

export default defineComponent({
  name: 'next-preview',
  emits: ['stop'],
  props: {
    showPreview: {
      type: Boolean,
      default: true,
    },
    showTime: {
      // 倒计时到多少展示预览
      type: Number,
      default: -1,
    },
    config: {
      type: Object as () => {
        title: string
        timer: number
        url: string
      },
      default: () => ({}),
    },
    previewIndex: {
      type: Number,
      default: 0,
    },
  },
  setup: (props, { emit }) => {
    // const bus = useBus()
    const componentStore = useComponentStore()
    const timer = ref<number>(0)
    let timerId: any = null
    watch(
      () => props.config,
      () => {
        if (props.previewIndex != 2) {
          timer.value = props.config.timer
          timerId && clearTimeout(timerId)
          timerId = setTimeout(() => {
            clearTimeout(timerId)
            emit('stop')
          }, timer.value * 1000)
        }
      },
      { immediate: true }
    )
    componentStore.bus.on('videoDuration', (audTime: number) => {
      if (audTime) {
        timer.value = audTime
        timerId && clearTimeout(timerId)
        timerId = setTimeout(() => {
          clearTimeout(timerId)
          emit('stop')
        }, timer.value * 1000)
      }
    })
    onUnmounted(() => {
      clearTimeout(timerId)
      timerId = null
    })
    return () => (
      <>
        {props.showPreview && (timer.value < props.showTime || props.showTime < 0) && (
          <div class={styles.nextPreviewPage}>
            <div class={styles.bottom}>
              <div class={styles.desc}>
                <img src={Play} alt="" />
                <span>下一幕展示</span>
                <span>「{`${props.config.title}`}」</span>
              </div>
            </div>
          </div>
        )}
      </>
    )
  },
})
